export const pickDataProps = (props) => {
    const result = {};
    for (const key in props) {
        if (key.startsWith('data-')) {
            result[key] = props[key];
        }
    }
    return result;
};
//# sourceMappingURL=pick-data-props.js.map